export interface Article {
  id: string;
  slug: string;
  title: string;
  excerpt: string;
  content: string;
  category: string;
  categorySlug: string;
  tags: string[];
  imageUrl: string;
  authorName: string;
  authorAvatar: string;
  publishedAt: string;
  readTime: string;
  views: number;
  isHot: boolean;
}

export const categories = [
  { name: '网红爆料', slug: 'wanghong', icon: 'ri-user-smile-line', description: '网红塌房、人设崩塌最新爆料' },
  { name: '明星黑料', slug: 'mingxing', icon: 'ri-star-line', description: '明星八卦、娱乐圈黑料大起底' },
  { name: '反差视频', slug: 'shipin', icon: 'ri-movie-line', description: '博主反差视频、惊人真相曝光' },
  { name: '社会大瓜', slug: 'shehui', icon: 'ri-fire-line', description: '社会热点、劲爆事件一网打尽' },
  { name: '直播翻车', slug: 'zhibo', icon: 'ri-live-line', description: '直播事故、主播翻车现场合集' },
  { name: '独家深扒', slug: 'shenba', icon: 'ri-search-eye-line', description: '深度调查、独家内幕揭秘' },
];

export const articles: Article[] = [
  {
    id: '1',
    slug: 'dingzhen-chugui-baoliao',
    title: '顶流男星深夜密会神秘女子，酒店监控曝光引热议',
    excerpt: '某顶流男星被拍到深夜与神秘女子同回酒店，疑似出轨实锤。知情人士透露两人已经秘密交往半年，更多细节持续深扒中...',
    content: `<p>近日，一则关于某顶流男星的爆料在网络上引发轩然大波。据知情人士透露，该男星在某次品牌活动结束后，并未按照行程返回安排好的酒店，而是独自驱车前往位于城郊的一家隐秘会所。</p><p>监控画面显示，一名身着黑色连衣裙的神秘女子早已在会所门口等候。两人见面后举止亲密，随后一同进入会所的VIP包间。据在场工作人员透露，两人在包间内逗留了约三个小时，直到凌晨两点才分别离开。</p><p>更加劲爆的是，该男星此前一直以"单身暖男"人设示人，在粉丝心目中形象正面。而这位神秘女子被扒出是某知名网红，在社交平台上拥有数百万粉丝。据两人共同好友爆料，他们实际上已经秘密交往超过半年。</p><p>目前，该男星的工作室尚未对此事作出任何回应。但不少品牌方已经开始紧急评估是否继续与该男星的代言合作。粉丝群体也出现了明显分裂，有人坚决维护偶像，有人则表示失望至极。</p><p>我们将持续关注此事的进展，为大家带来第一手的爆料信息。</p>`,
    category: '明星黑料',
    categorySlug: 'mingxing',
    tags: ['顶流', '出轨', '酒店', '监控', '实锤'],
    imageUrl: 'https://readdy.ai/api/search-image?query=Dark%20mysterious%20hotel%20corridor%20at%20night%20with%20dim%20red%20lighting%2C%20shadowy%20figures%2C%20cinematic%20noir%20style%2C%20luxury%20hotel%20interior%2C%20surveillance%20camera%20vibe%2C%20dark%20dramatic%20atmosphere%2C%20high%20contrast%2C%20professional%20cinematography%2C%20moody%20and%20tense%20mood&width=1200&height=675&seq=article-dingzhen-01&orientation=landscape',
    authorName: '吃瓜小队长',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Anonymous%20hacker%20style%20avatar%20with%20dark%20hood%2C%20mysterious%20vibe%2C%20dark%20background%2C%20simple%20minimal%20design%2C%20glowing%20red%20eyes%2C%20vector%20art%20style&width=100&height=100&seq=avatar-01&orientation=squarish',
    publishedAt: '2026-07-06T22:30:00Z',
    readTime: '5分钟',
    views: 128930,
    isHot: true,
  },
  {
    id: '2',
    slug: 'wanghong-daihuo-fanche',
    title: '千万粉丝网红直播带货翻车，假货实锤后连夜删视频',
    excerpt: '某千万级网红在直播间售卖所谓"大牌平替"化妆品，被消费者送检后发现成分严重超标。面对质问她选择连夜删除所有相关视频...',
    content: `<p>直播带货圈再次迎来大地震。一位拥有超过两千万粉丝的头部网红，在最近的一场直播中推销了一款号称"国际大牌平替"的面霜产品，声称该产品与某奢侈品牌使用同一生产线，价格却只要十分之一。</p><p>然而，有较真的消费者购买后将其送往第三方专业检测机构进行检测，结果令人震惊——该产品的重金属含量超过国家标准数倍，而且含有多种违禁添加成分。更令人愤怒的是，产品的备案信息与实际成分严重不符。</p><p>面对消费者和媒体的质询，该网红选择了一种令人不齿的处理方式：连夜删除了所有与该产品相关的直播回放和宣传视频，关闭了评论区，并对质疑的消费者进行了拉黑处理。</p><p>目前，市场监管部门已经介入调查。据业内人士分析，该网红可能面临巨额罚款，甚至有承担刑事责任的风险。多个品牌方也紧急发布了与该网红解约的声明。</p><p>这件事再次给广大消费者敲响了警钟：网红推荐不等于安全可靠，下单前还是要擦亮眼睛。</p>`,
    category: '网红爆料',
    categorySlug: 'wanghong',
    tags: ['直播带货', '假货', '翻车', '化妆品', '维权'],
    imageUrl: 'https://readdy.ai/api/search-image?query=Dark%20streaming%20studio%20setup%20with%20ring%20light%2C%20cosmetics%20products%20on%20table%2C%20dramatic%20red%20and%20black%20lighting%2C%20mysterious%20atmosphere%2C%20ecommerce%20livestream%20scene%2C%20cinematic%20noir%2C%20low%20key%20photography%2C%20tense%20dramatic%20mood%2C%20professional%20lighting&width=1200&height=675&seq=article-wanghong-02&orientation=landscape',
    authorName: '真相挖掘机',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Mysterious%20detective%20style%20avatar%20with%20magnifying%20glass%2C%20dark%20shadow%20figure%2C%20noir%20aesthetic%2C%20simple%20design%2C%20glowing%20green%20accent%2C%20vector%20art&width=100&height=100&seq=avatar-02&orientation=squarish',
    publishedAt: '2026-07-05T18:15:00Z',
    readTime: '4分钟',
    views: 98421,
    isHot: true,
  },
  {
    id: '3',
    slug: 'buzhuming-nvxing-sijiao-baoguang',
    title: '知名女星私教课录音曝光，内容劲爆颠覆清纯人设',
    excerpt: '一段据称是某当红女星与私人教练的对话录音在网上疯传，录音中涉及的内容与其平时塑造的清纯形象大相径庭...',
    content: `<p>一段时长约15分钟的录音文件近日在社交媒体上疯狂传播。据上传者称，这段录音记录了某当红一线女星与其私人健身教练之间的私密对话。录音中的女声与此前该女星在采访中的声音高度吻合。</p><p>录音中涉及了大量与其公众形象截然不同的内容。该女星在录音中以极其粗俗的言辞评价了多位圈内同行，甚至爆料了一些鲜为人知的行业内幕。这些言论与她在镜头前塑造的"温柔可人"、"清纯玉女"形象形成了巨大反差。</p><p>更令粉丝心碎的是，录音中还涉及了她对粉丝群体的真实看法。她将支持自己的粉丝形容为"提款机"，并表示自己只是在"表演"人设给粉丝看。</p><p>目前，该录音的真实性尚未得到官方证实，但多位音频分析专家表示，录音不存在剪辑拼接的痕迹。该女星的经纪公司发布声明称这是"恶意AI合成"，并表示将采取法律手段维权。</p><p>无论真相如何，这件事已经对该女星的事业造成了严重冲击，多个代言合作被紧急叫停。</p>`,
    category: '明星黑料',
    categorySlug: 'mingxing',
    tags: ['女星', '录音', '人设崩塌', '清纯', '震撼'],
    imageUrl: 'https://readdy.ai/api/search-image?query=Dark%20recording%20studio%20control%20room%20with%20audio%20waveforms%2C%20red%20and%20black%20color%20scheme%2C%20mysterious%20atmosphere%2C%20sound%20engineering%20equipment%2C%20noir%20cinematic%20style%2C%20dramatic%20lighting%2C%20professional%20photography%2C%20tense%20vibe&width=1200&height=675&seq=article-nvxing-03&orientation=landscape',
    authorName: '暗网特工',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Spy%20agent%20style%20avatar%20with%20dark%20sunglasses%2C%20mysterious%20vibe%2C%20black%20background%2C%20red%20glowing%20elements%2C%20minimal%20vector%20art&width=100&height=100&seq=avatar-03&orientation=squarish',
    publishedAt: '2026-07-04T14:00:00Z',
    readTime: '6分钟',
    views: 201456,
    isHot: true,
  },
  {
    id: '4',
    slug: 'fancha-bozhu-shuiqian-zhibo',
    title: '反差博主深夜直播失态，酒后吐真言引万人围观',
    excerpt: '一位以"正能量"著称的生活方式博主，在深夜直播中饮酒过量后情绪失控，说出了许多令人震惊的真实想法...',
    content: `<p>一位长期以"正能量生活博主"标签活跃在各大平台的知名博主，在昨日深夜的直播中发生了令人瞠目的翻车事件。</p><p>据了解，该博主当晚在直播间与粉丝进行日常互动，期间多次饮酒。随着酒精作用的加剧，她的状态开始失控。她先是声泪俱下地讲述了做博主的不易，随后话锋一转，开始大爆自己根本不认同自己一直倡导的"极简生活"理念，所有内容都是团队策划出来赚流量的。</p><p>更加精彩的还在后面。她开始逐一点评同行博主，用词犀利、毫不留情。她甚至爆料了某知名美妆博主私下整容失败的事实，以及某美食博主的"探店"视频全是收钱操作的真相。</p><p>尽管直播间管理多次试图切断直播，但直播信号"意外"持续了近一个小时，吸引了超过十万人同时在线围观。次日清晨，该博主发布了一条道歉声明，称自己"饮酒过量、情绪失控"，但这些话显然已经覆水难收。</p>`,
    category: '反差视频',
    categorySlug: 'shipin',
    tags: ['直播', '酒后', '反差', '翻车', '失控'],
    imageUrl: 'https://readdy.ai/api/search-image?query=Dark%20room%20with%20computer%20screen%20glowing%2C%20wine%20glass%20on%20desk%2C%20dramatic%20red%20and%20black%20lighting%2C%20streaming%20setup%2C%20emotional%20breakdown%20vibe%2C%20cinematic%20noir%2C%20low%20key%2C%20professional%20photography&width=1200&height=675&seq=article-fancha-04&orientation=landscape',
    authorName: '吃瓜小队长',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Anonymous%20hacker%20style%20avatar%20with%20dark%20hood%2C%20mysterious%20vibe%2C%20dark%20background%2C%20simple%20minimal%20design%2C%20glowing%20red%20eyes%2C%20vector%20art%20style&width=100&height=100&seq=avatar-01&orientation=squarish',
    publishedAt: '2026-07-03T23:45:00Z',
    readTime: '4分钟',
    views: 76230,
    isHot: false,
  },
  {
    id: '5',
    slug: 'shejiao-mingyuan-beihou-jiaoyi',
    title: '社交名媛圈惊人黑幕曝光，名包名表背后的灰色产业链',
    excerpt: '深入调查社交名媛圈背后的灰色产业，从租赁奢侈品到拼单拍摄，揭秘那些"白富美"人设背后的真实面目...',
    content: `<p>在社交媒体上，总有一群被称为"名媛"的女性账号，她们的生活似乎是由私人飞机、爱马仕限量包和五星级酒店的下午茶构成的。但真实情况究竟如何？我们的调查团队进行了为期三个月的深入暗访。</p><p>调查发现，一个完整的"名媛产业链"早已形成。在各大城市都存在专业的奢侈品租赁公司，这些公司专门为"名媛"们提供按天租赁服务。一只真品爱马仕铂金包的日租金在3000-5000元不等，而拍摄一组"名媛风格"的照片，全部道具租赁成本可以控制在万元以内。</p><p>更加令人震惊的是，一些高端的"名媛培训班"也应运而生。这些机构不仅教授"名媛"们如何穿搭、如何摆拍，甚至还手把手教她们如何在社交平台上筛选潜在目标——通常是有经济实力的中年男性，用行话来说就是"大哥"。</p><p>我们联系到了几位曾经深陷其中的当事人。她们透露，很多"名媛"的真实身份其实是普通人，有些甚至是刚刚毕业的大学生。她们被这条产业链吸引，希望通过包装自己的方式实现"阶层跃迁"，但最终往往陷入更深的泥潭。</p>`,
    category: '社会大瓜',
    categorySlug: 'shehui',
    tags: ['名媛', '黑幕', '产业链', '奢侈品', '人设'],
    imageUrl: 'https://readdy.ai/api/search-image?query=Dark%20luxury%20handbags%20displayed%20on%20shelf%2C%20shadowy%20figures%20in%20background%2C%20red%20and%20black%20lighting%2C%20luxury%20goods%20store%20atmosphere%2C%20noir%20cinematic%20style%2C%20mysterious%20vibe%2C%20high%20contrast%2C%20professional%20photography&width=1200&height=675&seq=article-mingyuan-05&orientation=landscape',
    authorName: '真相挖掘机',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Mysterious%20detective%20style%20avatar%20with%20magnifying%20glass%2C%20dark%20shadow%20figure%2C%20noir%20aesthetic%2C%20simple%20design%2C%20glowing%20green%20accent%2C%20vector%20art&width=100&height=100&seq=avatar-02&orientation=squarish',
    publishedAt: '2026-07-02T09:00:00Z',
    readTime: '7分钟',
    views: 135620,
    isHot: true,
  },
  {
    id: '6',
    slug: 'zhubo-bisaijian-zuobi',
    title: '电竞主播线下赛疑似作弊，监控记录关键画面引争议',
    excerpt: '某知名电竞主播在一场百万奖金的线下比赛中表现出超凡操作，但赛后流出的监控画面却让人产生怀疑...',
    content: `<p>电竞圈年度最受关注的一场线下邀请赛刚刚落幕，但赛后的争议却远比比赛本身更加精彩。</p><p>在这场总奖金高达百万的比赛中，某位拥有八百万粉丝的电竞主播表现神勇，以几乎零失误的操作碾压了多位职业选手，最终夺得冠军。这一结果立即在圈内引起了轩然大波，多位职业选手在社交媒体上暗示比赛存在不公平因素。</p><p>事情的转折点出现在赛后第二天。一位现场工作人员匿名向媒体提供了一段监控录像。画面显示，在比赛进行期间，有人频繁地在该主播身后走动，疑似在进行某种信息传递。另有观众拍摄的现场画面显示，该主播在操作时频繁地将视线移向屏幕以外的方向。</p><p>赛事主办方在舆论压力下发布声明，表示将成立独立的调查委员会对此事进行彻查。如果作弊行为被证实，该主播将面临终身禁赛、追回奖金以及巨额赔偿的处罚。</p>`,
    category: '直播翻车',
    categorySlug: 'zhibo',
    tags: ['电竞', '作弊', '直播', '比赛', '争议'],
    imageUrl: 'https://readdy.ai/api/search-image?query=Dark%20esports%20gaming%20arena%20with%20red%20and%20blue%20LED%20lights%2C%20gaming%20chairs%20and%20monitors%2C%20dramatic%20atmosphere%2C%20competition%20scene%2C%20cyberpunk%20vibe%2C%20noir%20style%2C%20professional%20photography%2C%20mysterious%20tone&width=1200&height=675&seq=article-esport-06&orientation=landscape',
    authorName: '暗网特工',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Spy%20agent%20style%20avatar%20with%20dark%20sunglasses%2C%20mysterious%20vibe%2C%20black%20background%2C%20red%20glowing%20elements%2C%20minimal%20vector%20art&width=100&height=100&seq=avatar-03&orientation=squarish',
    publishedAt: '2026-07-01T16:20:00Z',
    readTime: '3分钟',
    views: 56430,
    isHot: false,
  },
  {
    id: '7',
    slug: 'yulequan-tianjia-chouwen',
    title: '娱乐圈惊天大瓜：某制片人潜规则数十名新人演员',
    excerpt: '多名新人女演员联合实名举报某知名制片人，指控其在剧组面试期间进行不当行为，事件涉及人数之多令人震惊...',
    content: `<p>娱乐圈再次爆发重量级丑闻。昨日晚间，十八名曾经或正在演艺圈发展的新人女演员通过律师联合发布声明，实名举报某著名制片人在过去十年间存在系统性不当行为。</p><p>据联名举报信描述，这位在业内拥有极高话语权的制片人，利用其掌握的资源分配权和选角决定权，在剧组面试过程中对多名新人演员提出不当要求。举报信详细列举了时间、地点和具体经过，内容令人发指。</p><p>更令人震惊的是，举报信还揭露了一个系统性的"选角产业链"。该制片人并非单独行动，而是形成了一个由经纪公司、选角导演和其本人组成的关系网络。新人演员如果不"配合"，几乎无法在该制片人参与的任何项目中获得角色。</p><p>目前，多家影视行业协会已经发表声明谴责该行为，并表示将展开行业自律调查。涉事制片人所在的影视公司也紧急发布声明，称已暂停其一切职务，并将配合相关部门调查。</p>`,
    category: '独家深扒',
    categorySlug: 'shenba',
    tags: ['潜规则', '制片人', '新人演员', '举报', '娱乐圈'],
    imageUrl: 'https://readdy.ai/api/search-image?query=Dark%20film%20set%20with%20director%20chair%2C%20spotlight%20beam%2C%20shadowy%20atmosphere%2C%20red%20and%20black%20cinematic%20lighting%2C%20movie%20production%20scene%2C%20noir%20style%2C%20dramatic%20tension%2C%20professional%20photography&width=1200&height=675&seq=article-yule-07&orientation=landscape',
    authorName: '吃瓜小队长',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Anonymous%20hacker%20style%20avatar%20with%20dark%20hood%2C%20mysterious%20vibe%2C%20dark%20background%2C%20simple%20minimal%20design%2C%20glowing%20red%20eyes%2C%20vector%20art%20style&width=100&height=100&seq=avatar-01&orientation=squarish',
    publishedAt: '2026-06-30T11:30:00Z',
    readTime: '6分钟',
    views: 310280,
    isHot: true,
  },
  {
    id: '8',
    slug: 'wanghong-canyin-zhiwei-biaozhun',
    title: '网红餐厅后厨实拍曝光：蟑螂遍地食材过期仍正常营业',
    excerpt: '一家在社交平台评分极高的网红餐厅被暗访记者拍到后厨惊人画面，卫生状况堪忧却仍在正常接待顾客...',
    content: `<p>又一家网红餐厅塌房了。这家在某社交平台上拥有"年度最佳餐厅"称号、评分高达4.8分的网红餐厅，近日被暗访记者揭开了真面目。</p><p>根据暗访记者拍摄的画面显示，该餐厅的后厨环境卫生状况极为恶劣。地面上蟑螂随处可见，食材被随意堆放在潮湿的地面上，冰箱内大量食材已经超出保质期但仍在使用。更令人作呕的是，厨房工作人员在处理食材时完全没有佩戴手套，甚至在处理生肉和熟食之间也没有进行任何清洁。</p><p>然而，就是这样一个后厨如地狱般的餐厅，前厅却呈现出完全不同的景象——装修精致、服务热情、菜品摆盘精美。这种巨大的反差让无数光顾过的消费者感到恶心和后怕。</p><p>市场监管部门在接到举报后第一时间对该餐厅进行了突击检查，确认了暗访视频中的大部分问题属实。目前该餐厅已被责令停业整顿，并面临高额罚款。但消费者们更关心的是：还有多少网红餐厅在光鲜的外表下隐藏着同样肮脏的秘密？</p>`,
    category: '社会大瓜',
    categorySlug: 'shehui',
    tags: ['餐厅', '后厨', '卫生', '曝光', '暗访'],
    imageUrl: 'https://readdy.ai/api/search-image?query=Dark%20restaurant%20kitchen%20with%20dim%20lighting%2C%20dirty%20messy%20counter%2C%20shadowy%20atmosphere%2C%20health%20inspection%20vibe%2C%20noir%20style%2C%20red%20accent%20lighting%2C%20dramatic%20tension%2C%20professional%20photography%2C%20gritty%20texture&width=1200&height=675&seq=article-canyin-08&orientation=landscape',
    authorName: '真相挖掘机',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Mysterious%20detective%20style%20avatar%20with%20magnifying%20glass%2C%20dark%20shadow%20figure%2C%20noir%20aesthetic%2C%20simple%20design%2C%20glowing%20green%20accent%2C%20vector%20art&width=100&height=100&seq=avatar-02&orientation=squarish',
    publishedAt: '2026-06-29T08:00:00Z',
    readTime: '3分钟',
    views: 43210,
    isHot: false,
  },
  {
    id: '9',
    slug: 'daihuo-yige-benshi-xiangmu',
    title: '带货一哥被曝年收入超10亿，税务问题引相关部门关注',
    excerpt: '某直播带货一哥的疑似内部财务数据遭到泄露，其年收入数字令人咋舌，而与之相关的税务问题也引发关注...',
    content: `<p>一份据称来自某头部MCN机构内部的财务报表近日在网络上流传，披露了某位被誉为"带货一哥"的超级主播的真实收入情况。</p><p>根据这份报表显示，该主播在过去一个完整财年中，仅直播带货一项的佣金收入就高达8.7亿元，加上品牌代言费、出场费等其他收入，年度总收入突破了10亿元大关。这个数字不仅远远超出了该主播公开透露的收入水平，也超过了国内绝大多数上市公司的年利润。</p><p>更加引人关注的是报表中关于税务处理的部分。据财务专业人士分析，该主播通过多家壳公司和个人独资企业进行收入分拆，可能涉及利用税收优惠政策进行避税的问题。多个税务专家表示，这种操作的合法性和合理性都值得商榷。</p><p>目前，相关税务部门已经表示将关注此事。如果避税行为被查实，该主播可能面临数亿元的补税和罚款。与此同时，多家与他合作的品牌方也开始重新评估合作风险。</p>`,
    category: '网红爆料',
    categorySlug: 'wanghong',
    tags: ['带货', '收入', '税务', '数据泄露', '一哥'],
    imageUrl: 'https://readdy.ai/api/search-image?query=Dark%20luxurious%20office%20with%20money%20stacks%20on%20desk%2C%20financial%20documents%2C%20red%20and%20black%20lighting%2C%20corporate%20corruption%20vibe%2C%20noir%20cinematic%20style%2C%20dramatic%20atmosphere%2C%20professional%20photography&width=1200&height=675&seq=article-daihuo-09&orientation=landscape',
    authorName: '暗网特工',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Spy%20agent%20style%20avatar%20with%20dark%20sunglasses%2C%20mysterious%20vibe%2C%20black%20background%2C%20red%20glowing%20elements%2C%20minimal%20vector%20art&width=100&height=100&seq=avatar-03&orientation=squarish',
    publishedAt: '2026-06-28T15:40:00Z',
    readTime: '5分钟',
    views: 189540,
    isHot: true,
  },
];

export const testimonials = [
  {
    name: '匿名用户A',
    role: '资深吃瓜群众',
    content: '暗网吃瓜是我每天必刷的平台，信息更新速度太快了。每次有大瓜都是在这里第一时间看到的，比微博还快！',
    rating: 5,
    avatar: 'https://readdy.ai/api/search-image?query=Anonymous%20dark%20silhouette%20avatar%2C%20mysterious%20person%2C%20black%20background%2C%20simple%20minimal%20design%2C%20noir%20style%2C%20vector%20art&width=80&height=80&seq=testimonial-01&orientation=squarish',
  },
  {
    name: '八卦研究员',
    role: '媒体从业者',
    content: '作为一个做娱乐新闻的，暗网吃瓜给了我很多第一手线索。这里的爆料真实度很高，不是那种乱编的营销号内容。',
    rating: 5,
    avatar: 'https://readdy.ai/api/search-image?query=Detective%20style%20avatar%20with%20magnifying%20glass%2C%20dark%20theme%2C%20mysterious%20vibe%2C%20noir%20aesthetic%2C%20vector%20art&width=80&height=80&seq=testimonial-02&orientation=squarish',
  },
  {
    name: '吃瓜不嫌事大',
    role: '忠实用户',
    content: '从暗网吃瓜网站到暗网吃瓜app，我一直在用。界面简洁没有广告骚扰，内容质量也很高，推荐给所有爱吃瓜的朋友！',
    rating: 5,
    avatar: 'https://readdy.ai/api/search-image?query=Anonymous%20hacker%20style%20avatar%2C%20dark%20hood%2C%20green%20glowing%20elements%2C%20mysterious%20vibe%2C%20vector%20art&width=80&height=80&seq=testimonial-03&orientation=squarish',
  },
];

export const faqs = [
  { question: '暗网吃瓜网站是什么？', answer: '暗网吃瓜网站是一个专注于网红塌房、明星黑料、博主反差视频等娱乐八卦内容的资讯平台。我们致力于为用户提供最新、最全、最真实的爆料信息，让每一位吃瓜群众都能第一时间吃到大瓜。' },
  { question: '暗网吃瓜app在哪里下载？', answer: '暗网吃瓜app目前支持iOS和Android双平台下载。您可以在本页面直接扫描二维码或在各大应用商店搜索"暗网吃瓜"进行下载安装。app版本更新更及时，推送更快速。' },
  { question: '暗网吃瓜的内容真实可靠吗？', answer: '我们所有内容均来自多方信源交叉验证，确保信息的真实性和可靠性。对于尚未完全证实的爆料，我们会在文章中明确标注"待证实"标签，让用户理性吃瓜。' },
  { question: '如何获取暗网吃瓜的最新地址？', answer: '暗网吃瓜永久更新入口会在本页面持续更新。建议您收藏本站或下载暗网吃瓜app，以确保第一时间获取最新内容。如遇访问问题，可通过我们的官方社交媒体账号获取最新地址。' },
  { question: '暗网吃瓜如何保护用户隐私？', answer: '我们高度重视用户隐私保护。浏览暗网吃瓜网站和使用暗网吃瓜app均无需注册登录，我们不会收集任何用户的个人信息。所有评论和互动均为匿名进行，确保用户可以自由表达观点。' },
];